// src/components/VideoEngine/Templates/MSN_Landscape/Sequences/Outro.js

import React from "react";
import { AbsoluteFill, Sequence, OffthreadVideo, Audio, Img, useCurrentFrame, interpolate } from "remotion";
import { KaraokeCaptions } from "../../../Common/KaraokeCaptions";

export const OutroSlide = ({
  item,
  theme,
  ENABLE_AUDIO = true,
  brand,
  backgroundVideo, // <--- 1. NEW PROP ACCEPTED HERE
  pexelsCredit,
}) => {
  const frame = useCurrentFrame();
  const pan = interpolate(frame, [0, 150], [0, -50]);

  // --- 2. DYNAMIC SOURCE SELECTION ---
  // Priority 1: The Global B-Roll (from Pexels/Lab Page)
  // Priority 2: A fallback default (Abstract purple fluid)
  //const videoSrc = backgroundVideo || "https://www.pexels.com/download/video/6003440/"; // Toprical; boat, drone
  const videoSrc = backgroundVideo || "https://www.pexels.com/download/video/34623325/"; // Mountains, drone

  // CAPTURE THE DELAY
  const audioOffset = item.audioDelay || 0;

  // The Watermark Fade ---
  const watermarkOpacity = interpolate(
    frame - audioOffset,
    [0, 30],     // Over the first 30 active frames...
    [0, 0.6],    // Fade from 0% to a subtle 60% opacity
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  return (
    <AbsoluteFill style={{ backgroundColor: "#0f172a" }}>
      {ENABLE_AUDIO && item.props?.audioUrl && (
        <Sequence from={item.audioDelay || 0}>
          <Audio src={item.props.audioUrl} />
        </Sequence>
      )}

      {/* VIDEO BG */}
      <AbsoluteFill
        style={{
          maskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 30%, rgba(0,0,0,0) 85%)",
          WebkitMaskImage: "linear-gradient(to bottom, rgba(0,0,0,1) 30%, rgba(0,0,0,0) 85%)",
          height: "100%",
          zIndex: 1,
        }}
      >
        <OffthreadVideo // <--- REPLACED 'Video'
          src={videoSrc}
          muted={true}
          style={{
            width: "100%",
            height: "120%",
            objectFit: "cover",
            transform: `translateY(${pan}px)`,
          }}
        //muted
        //loop
        // muted and loop are no longer required/supported for OffthreadVideo
        />
      </AbsoluteFill>

      {/* --- NEW: THE ATTRIBUTION OVERLAY --- */}
      {pexelsCredit && (
        <AbsoluteFill
          style={{
            zIndex: 10, 
            justifyContent: "flex-end",
            alignItems: "flex-end",
            //padding: "20px 30px",
            paddingBottom: 30, // Sits strictly beneath the Brand Lockup, avoiding the 12px progress bar
            paddingRight: 65,
          }}
        >
          <div
            style={{
              transform: "translateZ(0)", // Forces GPU acceleration
            }}
          >
            <p
              style={{
                color: "rgba(255, 255, 255, 0.5)",
                fontFamily: theme.fontMain,
                fontSize: 10,
                margin: 0,
                fontWeight: 400,
                letterSpacing: 1,
                textTransform: "uppercase",
                textShadow: "0px 2px 4px rgba(0,0,0,0.5)",
              }}
            >
              {/* Video by <span style={{ color: "white", fontWeight: 700 }}>{pexelsCredit}</span> / Pexels */}
              {pexelsCredit} / Pexels
            </p>
          </div>
        </AbsoluteFill>
      )}

      {/* CONTENT */}
      <AbsoluteFill
        style={{
          zIndex: 3,
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            paddingTop: "60px",
            paddingBottom: "100px",
            background: "linear-gradient(to top, #0f172a 50%, transparent 100%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* Centered Brand Logo */}
          <Img
            src="https://firebasestorage.googleapis.com/v0/b/freelancer-ideas-portal.firebasestorage.app/o/adaptation_engine%2Fbrand_assets%2Floveinc.png?alt=media&token=22866cd2-1b3b-4c74-9e24-762e6cfd2c33"
            style={{
              height: 120,
              width: "auto",
              marginBottom: 40,
              opacity: 0.9,
              filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.6))"
            }}
          />
          <h1
            style={{
              color: "white",
              fontFamily: theme.fontDisplay || theme.fontMain,
              fontSize: 100,
              lineHeight: 0.9,
              margin: "0 0 20px 0",
              textTransform: "uppercase",
              textShadow: "0 10px 30px rgba(0,0,0,0.5)",
            }}
          >
            {item.text || "READ MORE"}
          </h1>

          {/* KARAOKE */}
          {item.captions && item.captions.length > 0 && (
            <div style={{
              maxWidth: "80%",
              marginBottom: 30,
              paddingTop: "10px",
              fontSize: 46,
              fontFamily: theme.fontMain,
              display: 'flex',
              justifyContent: 'center'
            }}>
              <KaraokeCaptions
                captions={item.captions}
                theme={theme}
                delay={item.audioDelay || 0}
              />
            </div>
          )}

          {/* 5. BRAND LOCKUP (Relocated to Bottom Right) */}
          <div
            style={{
              position: "absolute",
              bottom: 50, // <--- Nestles perfectly above the 12px progress bar
              right: 60,  // <--- Aligns vertically with the top-right watermark bug
              zIndex: 9,
              opacity: watermarkOpacity, // <--- Recycles our elegant 30-frame fade
              willChange: "opacity",
            }}
          >
            <h3
              style={{
                color: "white",
                fontFamily: theme.fontMain,
                fontWeight: 700, // <--- Bolder weight to ensure it punches through background noise
                letterSpacing: 4,
                margin: 0,
                fontSize: 26,
                textShadow: "0px 4px 15px rgba(0,0,0,0.9)", // <--- THE ARMOR: Heavy shadow ensures legibility on bright/white photos
              }}
            >
              LOVE{brand ? brand.toUpperCase() : "INC"}
            </h3>
          </div>

          <h3
            style={{
              color: theme.primary,
              fontFamily: theme.fontMain,
              fontWeight: 900,
              letterSpacing: 4,
              margin: 0,
              fontSize: 34,
              textTransform: "uppercase",
            }}
          >
            LIKE AND FOLLOW FOR MORE!
          </h3>
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};